/**
 * Constants for Birthday Voucher Modal
 * Centralized configuration to eliminate magic numbers and improve maintainability
 */
/**
 * Number of days after user's birthday to show the voucher modal
 * This represents the grace period where users can still claim their birthday voucher
 */
export var DEFAULT_BIRTHDAY_VOUCHER_DISPLAY_DAYS = 7;
/**
 * Number of milliseconds in one day
 * Used for cookie expiration calculations
 */
export var ONE_DAY = 86400000;
